
export const garzaRete = {

    "title": "Van cleef Garza",
    "subtitle": "COLLECTION",
    "descriptionITA": "Una collezione organica, su garze e reti naturali di lino ricamato con l’iconico disegno Van cleef. Linee morbide ed eleganti.",
    "descriptionENG": "An organic collection on gauze and natural linen netting embroidered with the iconic Van cleef pattern. Soft and elegant lines."
};

export const lino = {

    "title": "Iconic",
    "subtitle": "COLLECTION",
    "descriptionITA": "La nostra linea sartoriale su 100% lino, sostenibile, ecologica. Una capsule classica piena di elementi sartoriali come eleganti camicie con pieghe, plissé che impreziosiscono orli e polsini, per un guardaroba estivo classico ma di tendenza. I colori ispirati ai fondali del mare e ai suoi coralli.",
    "descriptionENG": "Our sartorial line on 100% linen, sustainable, eco-friendly. A classic capsule full of sartorial elements such as elegant shirts with pleats, pleats embellish hems and cuffs, for a classic yet trendy summer wardrobe. The colors inspired by the seabed and its corals."

};


export const garzaReteProducts = [
    {
        "photo": "lookbook3/1_garzaRete/raw/20TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO2copia.jpg",
        "retro": "lookbook3/1_garzaRete/raw/20TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO7COPIA.jpg",
        "photomin": "lookbook3/1_garzaRete/min/20TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO2copia.jpg",
        "retromin": "lookbook3/1_garzaRete/min/20TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO7COPIA.jpg",

        "prod1": "TOP FALANGHINA",
        "stile1": "Colori Garza - Colori Uniti Lino | Ric. Smeraldo | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "SHORT SISMA",
        "stile2": "Colori Garza - Colori Lino | Ric. Smeraldo | Stampe Lino",
        "taglia2": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/21-SPOLVERINO-ORGOGLIO-U-COLORI-GARZA-RICAMO-SMERALDO4COPIA.jpg",
        "retro": "lookbook3/1_garzaRete/raw/21-SPOLVERINO-ORGOGLIO-U-COLORI-GARZA-RICAMO-SMERALDO13COPIA.jpg",
        "photomin": "lookbook3/1_garzaRete/min/21-SPOLVERINO-ORGOGLIO-U-COLORI-GARZA-RICAMO-SMERALDO4COPIA.jpg",
        "retromin": "lookbook3/1_garzaRete/min/21-SPOLVERINO-ORGOGLIO-U-COLORI-GARZA-RICAMO-SMERALDO13COPIA.jpg",
        "prod1": "SPOLVERINO ORGOGLIO",
        "stile1": "Colori Garza | Ric. Smeraldo",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/22-ABITO-NOVELLO-SML-COLORI-GARZA-RICAMO-SMERALDO3copia.jpg",
        "retro": "lookbook3/1_garzaRete/raw/22-ABITO-NOVELLO-SML-COLORI-GARZA-RICAMO-SMERALDO8copia.jpg",
        "photomin": "lookbook3/1_garzaRete/min/22-ABITO-NOVELLO-SML-COLORI-GARZA-RICAMO-SMERALDO3copia.jpg",
        "retromin": "lookbook3/1_garzaRete/min/22-ABITO-NOVELLO-SML-COLORI-GARZA-RICAMO-SMERALDO8copia.jpg",
        "prod1": "ABITO NOVELLO",
        "stile1": "Colori Garza | Ric. Smeraldo",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/23-ABITO-KATE-U-COLORI-GARZA-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE9.jpg",
        "retro": "lookbook3/1_garzaRete/raw/23-ABITO-KATE-U-COLORI-GARZA-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE13.jpg",
        "photomin": "lookbook3/1_garzaRete/min/23-ABITO-KATE-U-COLORI-GARZA-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE9.jpg",
        "retromin": "lookbook3/1_garzaRete/min/23-ABITO-KATE-U-COLORI-GARZA-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE13.jpg",
        "prod1": "ABITO KATE",
        "stile1": "Colori Garza",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MUSA",
        "stile2": "Colori Garza | Colori Rete",
        "taglia2": "TAGLIA SMLXL",

        "prod3": "SPOLVERINO BELEN",
        "stile3": "Colori Garza | Stampe Voile",
        "taglia3": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE-GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE-TOP-PREGIUDIZIO-U-COLORI-GARZA7.jpg",
        "retro": "lookbook3/1_garzaRete/raw/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE-GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE-TOP-PREGIUDIZIO-U-COLORI-GARZA8.jpg",
        "photomin": "lookbook3/1_garzaRete/min/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE-GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE-TOP-PREGIUDIZIO-U-COLORI-GARZA7.jpg",
        "retromin": "lookbook3/1_garzaRete/min/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE-GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE-TOP-PREGIUDIZIO-U-COLORI-GARZA8.jpg",
        "prod1": "PANTALONE MUSA",
        "stile1": "Colori Garza | Colori Rete",
        "taglia1": "TAGLIA SMLXL",

        "prod2": "TOP PREGIUDIZIO",
        "stile2": "Colori Garza",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE--TOP-PREGIUDIZIO-U-COLORI-GARZA12.jpg",
        "retro": "lookbook3/1_garzaRete/raw/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE--TOP-PREGIUDIZIO-U-COLORI-GARZA16.jpg",
        "photomin": "lookbook3/1_garzaRete/min/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE--TOP-PREGIUDIZIO-U-COLORI-GARZA12.jpg",
        "retromin": "lookbook3/1_garzaRete/min/24-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE--GIACCA-SENTIMENTO-U-COLORI-GARZA-COLORI-RETE--TOP-PREGIUDIZIO-U-COLORI-GARZA16.jpg",
        "prod1": "PANTALONE MUSA",
        "stile1": "Colori Garza | Colori Rete",
        "taglia1": "TAGLIA SMLXL",

        "prod2": "TOP PREGIUDIZIO",
        "stile2": "Colori Garza",
        "taglia2": "TAGLIA UNICA",

        "prod3": "GIACCA SENTIMENTO",
        "stile3": "Colori Garza | Colori Rete",
        "taglia3": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/25-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-----PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE6.jpg",
        "retro": "lookbook3/1_garzaRete/raw/25-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-----PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE22.jpg",
        "photomin": "lookbook3/1_garzaRete/min/25-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-----PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE6.jpg",
        "retromin": "lookbook3/1_garzaRete/min/25-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-----PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE22.jpg",
        "prod1": "CASACCA FANTASIA",
        "stile1": "Colori Garza | Colori Rete",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE RIESLING",
        "stile2": "Colori Lino | Stampe Lino",
        "taglia2": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/27-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO-1.jpg",
        "retro": "lookbook3/1_garzaRete/raw/27-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO-7.jpg",
        "photomin": "lookbook3/1_garzaRete/min/27-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO-1.jpg",
        "retromin": "lookbook3/1_garzaRete/min/27-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO-7.jpg",
        "prod1": "ABITO IMBRONCIATO",
        "stile1": "Colori Lino - Colori Garza | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/28-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA1.jpg",
        "retro": "lookbook3/1_garzaRete/raw/28-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA9.jpg",
        "photomin": "lookbook3/1_garzaRete/min/28-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA1.jpg",
        "retromin": "lookbook3/1_garzaRete/min/28-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA9.jpg",
        "prod1": "ABITO SCOSTUMATA",
        "stile1": "ECRU' BIANCO - ECRU' GARZA",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/30-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE3.jpg",
        "retro": "lookbook3/1_garzaRete/raw/30-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE11.jpg",
        "photomin": "lookbook3/1_garzaRete/min/30-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE3.jpg",
        "retromin": "lookbook3/1_garzaRete/min/30-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE11.jpg",
        "prod1": "CASACCA FANTASIA",
        "stile1": "Colori Garza | Colori Rete",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MUSA",
        "stile2": "Colori Garza | Colori Rete",
        "taglia2": "TAGLIA SMLXL",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/31-ABITO-BRENDA-U-COLORI-GARZA-COLORI-RETE5.jpg",
        "retro": "lookbook3/1_garzaRete/raw/31-ABITO-BRENDA-U-COLORI-GARZA-COLORI-RETE12.jpg",
        "photomin": "lookbook3/1_garzaRete/min/31-ABITO-BRENDA-U-COLORI-GARZA-COLORI-RETE5.jpg",
        "retromin": "lookbook3/1_garzaRete/min/31-ABITO-BRENDA-U-COLORI-GARZA-COLORI-RETE12.jpg",
        "prod1": "ABITO BRENDA",
        "stile1": "Colori Garza | Colori Rete",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/32-ABITO-RODA-U-COLORI-GARZA3.jpg",
        "retro": "lookbook3/1_garzaRete/raw/32-ABITO-RODA-U-COLORI-GARZA9.jpg",
        "photomin": "lookbook3/1_garzaRete/min/32-ABITO-RODA-U-COLORI-GARZA3.jpg",
        "retromin": "lookbook3/1_garzaRete/min/32-ABITO-RODA-U-COLORI-GARZA9.jpg",
        "prod1": "ABITO RODA",
        "stile1": "Colori Garza",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/33-ABITO-MELODIA-U-COLORI-GARZA3.jpg",
        "retro": "lookbook3/1_garzaRete/raw/33-ABITO-MELODIA-U-COLORI-GARZA14.jpg",
        "photomin": "lookbook3/1_garzaRete/min/33-ABITO-MELODIA-U-COLORI-GARZA3.jpg",
        "retromin": "lookbook3/1_garzaRete/min/33-ABITO-MELODIA-U-COLORI-GARZA14.jpg",
        "prod1": "ABITO MELODIA",
        "stile1": "Colori Garza",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/35TUTA-AMBRA-U-COLORI-GARZA-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE-VERDE-SMERALDO9.jpg",
        "retro": "lookbook3/1_garzaRete/raw/35TUTA-AMBRA-U-COLORI-GARZA-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE-VERDE-SMERALDO12.jpg",
        "photomin": "lookbook3/1_garzaRete/min/35TUTA-AMBRA-U-COLORI-GARZA-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE-VERDE-SMERALDO9.jpg",
        "retromin": "lookbook3/1_garzaRete/min/35TUTA-AMBRA-U-COLORI-GARZA-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE-VERDE-SMERALDO12.jpg",
        "prod1": "TUTA AMBRA",
        "stile1": "Colori Garza",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SPOLVERINO BELEN",
        "stile2": "Colori Garza | Stampe Voile | Verde Smeraldo",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/1_garzaRete/raw/34-ABITO-SUNRISE-U-COLORI-GARZA-COLORI-RETE-SPOLVERINO-SUPER-U-COLORI-GARZA-COLORI-RETE3.jpg",
        "retro": "lookbook3/1_garzaRete/raw/34-ABITO-SUNRISE-U-COLORI-GARZA-COLORI-RETE-SPOLVERINO-SUPER-U-COLORI-GARZA-COLORI-RETE9.jpg",
        "photomin": "lookbook3/1_garzaRete/min/34-ABITO-SUNRISE-U-COLORI-GARZA-COLORI-RETE-SPOLVERINO-SUPER-U-COLORI-GARZA-COLORI-RETE3.jpg",
        "retromin": "lookbook3/1_garzaRete/min/34-ABITO-SUNRISE-U-COLORI-GARZA-COLORI-RETE-SPOLVERINO-SUPER-U-COLORI-GARZA-COLORI-RETE9.jpg",
        "prod1": "ABITO SUNRISE",
        "stile1": "Colori Garza | Colori Rete",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SPOLVERINO SUPER",
        "stile2": "Colori Garza | Colori Rete",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    }
];
export const linoProducts = [
    {
        "photo": "lookbook3/2_lino/raw/35TUTA-AMBRA-U-COLORI-GARZA--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE4.jpg",
        "retro": "lookbook3/2_lino/raw/35TUTA-AMBRA-U-COLORI-GARZA--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE15.jpg",
        "photomin": "lookbook3/2_lino/min/35TUTA-AMBRA-U-COLORI-GARZA--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE4.jpg",
        "retromin": "lookbook3/2_lino/min/35TUTA-AMBRA-U-COLORI-GARZA--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE15.jpg",
        "prod1": "TUTA MARE",
        "stile1": "Colori Garza",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/37-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO--CINTURA-ZIONE-U-COLORI-LINO-STAMPA-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/37-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO--CINTURA-ZIONE-U-COLORI-LINO-STAMPA-LINO6.jpg",
        "photomin": "lookbook3/2_lino/min/37-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO--CINTURA-ZIONE-U-COLORI-LINO-STAMPA-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/37-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO--CINTURA-ZIONE-U-COLORI-LINO-STAMPA-LINO6.jpg",
        "prod1": "TUTA MASCALZONE",
        "stile1": "Colori Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA4.jpg",
        "retro": "lookbook3/2_lino/raw/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA5.jpg",
        "photomin": "lookbook3/2_lino/min/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA4.jpg",
        "retromin": "lookbook3/2_lino/min/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA5.jpg",
        "prod1": "ABITO AGADI",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "CINTURA ZIONE",
        "stile2": "Colori Lino | Stampa Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA7.jpg",
        "retro": "lookbook3/2_lino/raw/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA15.jpg",
        "photomin": "lookbook3/2_lino/min/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA7.jpg",
        "retromin": "lookbook3/2_lino/min/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA15.jpg",
        "prod1": "ABITO SCOSTUMATA",
        "stile1": "Ecrù Bianco | Ecrù Garza",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/39-CAMICIA-SUSHI-SMLXL-COLORI-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/39-CAMICIA-SUSHI-SMLXL-COLORI-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO6.jpg",
        "photomin": "lookbook3/2_lino/min/39-CAMICIA-SUSHI-SMLXL-COLORI-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/39-CAMICIA-SUSHI-SMLXL-COLORI-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO6.jpg",
        "prod1": "CAMICIA SUSHI",
        "stile1": "Colori Lino",
        "taglia1": "TAGLIA SMLXL",

        "prod2": "PANTALONE CAPRI",
        "stile2": "Colori Lino",
        "taglia2": "TAGLIA SMLXL",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/40-ABITO-RIBOLLA-SML-COLORI-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/40-ABITO-RIBOLLA-SML-COLORI-LINO5.jpg",
        "photomin": "lookbook3/2_lino/min/40-ABITO-RIBOLLA-SML-COLORI-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/40-ABITO-RIBOLLA-SML-COLORI-LINO5.jpg",
        "prod1": "ABITO RIBOLLA",
        "stile1": "Colori Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/41-CAMICIA-PINOT-SML-COLORI-LINO--PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/41-CAMICIA-PINOT-SML-COLORI-LINO--PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO4.jpg",
        "photomin": "lookbook3/2_lino/min/41-CAMICIA-PINOT-SML-COLORI-LINO--PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/41-CAMICIA-PINOT-SML-COLORI-LINO--PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO4.jpg",
        "prod1": "CAMICIA PINOT",
        "stile1": "Colori Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE RIESLING",
        "stile2": "Colori Lino | Stampe Lino",
        "taglia2": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO13.jpg",
        "retro": "lookbook3/2_lino/raw/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO18.jpg",
        "photomin": "lookbook3/2_lino/min/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO13.jpg",
        "retromin": "lookbook3/2_lino/min/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO18.jpg",
        "prod1": "ABITO YUKI",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/44-ABITO-MAKUMBA-U-COLORI-LINO43-ABITO-PROSECCO-U-COLORI-LINO-STAMPE-LINO9.jpg",
        "retro": "lookbook3/2_lino/raw/44-ABITO-MAKUMBA-U-COLORI-LINO43-ABITO-PROSECCO-U-COLORI-LINO-STAMPE-LINO8.jpg",
        "photomin": "lookbook3/2_lino/min/44-ABITO-MAKUMBA-U-COLORI-LINO43-ABITO-PROSECCO-U-COLORI-LINO-STAMPE-LINO9.jpg",
        "retromin": "lookbook3/2_lino/min/44-ABITO-MAKUMBA-U-COLORI-LINO43-ABITO-PROSECCO-U-COLORI-LINO-STAMPE-LINO8.jpg",
        "prod1": "ABITO MAKUMBA",
        "stile1": "Colori Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/45-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO3.jpg",
        "retro": "lookbook3/2_lino/raw/45-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO5.jpg",
        "photomin": "lookbook3/2_lino/min/45-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO3.jpg",
        "retromin": "lookbook3/2_lino/min/45-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO5.jpg",
        "prod1": "TUTA BAIA",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/46CASACCA-ROSA-SML-COLORI-LINO-STAMPE-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO4.jpg",
        "retro": "lookbook3/2_lino/raw/46CASACCA-ROSA-SML-COLORI-LINO-STAMPE-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO8.jpg",
        "photomin": "lookbook3/2_lino/min/46CASACCA-ROSA-SML-COLORI-LINO-STAMPE-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO4.jpg",
        "retromin": "lookbook3/2_lino/min/46CASACCA-ROSA-SML-COLORI-LINO-STAMPE-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO8.jpg",
        "prod1": "CASACCA ROSA",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE CAPRI",
        "stile2": "Colori Lino",
        "taglia2": "TAGLIA SMLXL",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/47-CASACCA-BAROLO-U-COLORI-UNITI-STAMPE-LINO-PANTALONE-MARTE-SMLXL-COLORI-UNITI1.jpg",
        "retro": "lookbook3/2_lino/raw/47-CASACCA-BAROLO-U-COLORI-UNITI-STAMPE-LINO-PANTALONE-MARTE-SMLXL-COLORI-UNITI6.jpg",
        "photomin": "lookbook3/2_lino/min/47-CASACCA-BAROLO-U-COLORI-UNITI-STAMPE-LINO-PANTALONE-MARTE-SMLXL-COLORI-UNITI1.jpg",
        "retromin": "lookbook3/2_lino/min/47-CASACCA-BAROLO-U-COLORI-UNITI-STAMPE-LINO-PANTALONE-MARTE-SMLXL-COLORI-UNITI6.jpg",
        "prod1": "CASACCA BAROLO",
        "stile1": "Colori Uniti | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MARTE",
        "stile2": "Colori Uniti",
        "taglia2": "TAGLIA SMLXL",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/48TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO-PANTALONE-MEGAN-SML-COLORI-UNITI-STAMPE-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/48TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO-PANTALONE-MEGAN-SML-COLORI-UNITI-STAMPE-LINO10.jpg",
        "photomin": "lookbook3/2_lino/min/48TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO-PANTALONE-MEGAN-SML-COLORI-UNITI-STAMPE-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/48TOP-FALANGHINA-SML-COLORI-GARZA-COLORI-UNITI-LINO-STAMPE-LINO----RIC.SMARALDO-PANTALONE-MEGAN-SML-COLORI-UNITI-STAMPE-LINO10.jpg",
        "prod1": "TOP FALANGHINA",
        "stile1": "Colori Garza | Colori Uniti Lino | Stampe Lino | Ric. Smeraldo",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MEGAN",
        "stile2": "Colori Uniti | Stampe Lino",
        "taglia2": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/49TOP-MISAKI-SML-COLORI-LINO-COLORI-GARZA-PANTALONE-GENIUS-SML-COLORI-LINO-COLORI-GARZA10.jpg",
        "retro": "lookbook3/2_lino/raw/49TOP-MISAKI-SML-COLORI-LINO-COLORI-GARZA-PANTALONE-GENIUS-SML-COLORI-LINO-COLORI-GARZA12.jpg",
        "photomin": "lookbook3/2_lino/min/49TOP-MISAKI-SML-COLORI-LINO-COLORI-GARZA-PANTALONE-GENIUS-SML-COLORI-LINO-COLORI-GARZA10.jpg",
        "retromin": "lookbook3/2_lino/min/49TOP-MISAKI-SML-COLORI-LINO-COLORI-GARZA-PANTALONE-GENIUS-SML-COLORI-LINO-COLORI-GARZA12.jpg",
        "prod1": "TOP MISAKI",
        "stile1": "Colori Lino | Colori Garza",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE GENIUS",
        "stile2": "Colori Lino | Colori Garza",
        "taglia2": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/50-ABITO-COCO-U-COLORI-LINO-STAMPE-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/50-ABITO-COCO-U-COLORI-LINO-STAMPE-LINO9.jpg",
        "photomin": "lookbook3/2_lino/min/50-ABITO-COCO-U-COLORI-LINO-STAMPE-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/50-ABITO-COCO-U-COLORI-LINO-STAMPE-LINO9.jpg",
        "prod1": "ABITO COCO",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/51ABITO-MAYA-U-COLORI-LINO-STAMPE-LINO3.jpg",
        "retro": "lookbook3/2_lino/raw/51ABITO-MAYA-U-COLORI-LINO-STAMPE-LINO10.jpg",
        "photomin": "lookbook3/2_lino/min/51ABITO-MAYA-U-COLORI-LINO-STAMPE-LINO3.jpg",
        "retromin": "lookbook3/2_lino/min/51ABITO-MAYA-U-COLORI-LINO-STAMPE-LINO10.jpg",
        "prod1": "ABITO MAYA",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/52-ABITO-ELECTRA-SML-COLORI-LINO-STAMPE-LINO1.jpg",
        "retro": "lookbook3/2_lino/raw/52-ABITO-ELECTRA-SML-COLORI-LINO-STAMPE-LINO9.jpg",
        "photomin": "lookbook3/2_lino/min/52-ABITO-ELECTRA-SML-COLORI-LINO-STAMPE-LINO1.jpg",
        "retromin": "lookbook3/2_lino/min/52-ABITO-ELECTRA-SML-COLORI-LINO-STAMPE-LINO9.jpg",
        "prod1": "ABITO ELECTRA",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/53-ABITO-DOLCETTO-U-COLORI-LINO-STAMPE-LINO4.jpg",
        "retro": "lookbook3/2_lino/raw/53-ABITO-DOLCETTO-U-COLORI-LINO-STAMPE-LINO9.jpg",
        "photomin": "lookbook3/2_lino/min/53-ABITO-DOLCETTO-U-COLORI-LINO-STAMPE-LINO4.jpg",
        "retromin": "lookbook3/2_lino/min/53-ABITO-DOLCETTO-U-COLORI-LINO-STAMPE-LINO9.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/54-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO4.jpg",
        "retro": "lookbook3/2_lino/raw/54-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO8.jpg",
        "photomin": "lookbook3/2_lino/min/54-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO4.jpg",
        "retromin": "lookbook3/2_lino/min/54-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO8.jpg",
        "prod1": "ABITO IMBRONCIATO",
        "stile1": "Colori Lino | Colori Garza | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook3/2_lino/raw/59GIACCA-GHANDI-U-COLORI-LINO9.jpg",
        "retro": "lookbook3/2_lino/raw/59GIACCA-GHANDI-U-COLORI-LINO5.jpg",
        "photomin": "lookbook3/2_lino/min/59GIACCA-GHANDI-U-COLORI-LINO9.jpg",
        "retromin": "lookbook3/2_lino/min/59GIACCA-GHANDI-U-COLORI-LINO5.jpg",
        "prod1": "GIACCA GHANDI",
        "stile1": "Colori Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    }
];
